import ContactForm from './components/ContactForm';
import { useSeo } from '@/hooks/useSeo';

const team = [
  { name: '陈明', role: '内容主编', desc: '十年影视内容运营经验，负责影片收录与专题策划。', icon: 'ri-book-2-line' },
  { name: '林菲', role: '产品负责人', desc: '专注用户体验设计，让找片与观影流程更顺畅。', icon: 'ri-layout-masonry-line' },
  { name: '赵宇', role: '技术负责人', desc: '负责平台性能与播放体验的持续优化。', icon: 'ri-code-s-slash-line' },
  { name: '苏晴', role: '社区运营', desc: '倾听影迷声音，让平台更懂观众的需求。', icon: 'ri-chat-smile-2-line' },
];

export default function About() {
  useSeo({
    title: '关于我们 - 6080yy电影在线看',
    description:
      '6080yy电影在线看是一个面向影迷的高清电影内容平台，提供便捷的影片搜索、分类浏览与观影体验。了解我们的团队、服务与联系方式。',
    keywords: '关于我们,6080yy电影在线看,电影平台介绍,在线电影网站',
  });

  return (
    <div className="w-full">
      <div className="w-full bg-primary-600">
        <div className="w-full px-4 md:px-6 py-12 md:py-16 text-center">
          <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-background-50">关于我们</h1>
          <p className="mt-3 text-sm md:text-base text-background-200/85 max-w-2xl mx-auto leading-relaxed">
            我们希望通过简单、清爽的方式，帮助每一位影迷更快地发现值得一看的好电影。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-4">
              <span>网站简介</span>
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-loose">
              <p>
                6080yy电影在线看是一个专注于高清电影内容展示的在线平台，面向广泛的电影爱好者，汇集动作、科幻、爱情、悬疑、恐怖、动画、剧情、战争、犯罪等多种类型的影片资源。
              </p>
              <p>
                平台提供关键词搜索、分类浏览、多维筛选与详情查看等功能，帮助用户快速定位感兴趣的作品。影片列表与详情页数据保持一致，涵盖不同地区与年代的内容，方便对比与挑选。
              </p>
              <p>
                需要说明的是，本站的视频播放功能目前为界面演示，未接入真实视频流，仅用于展示产品形态。我们持续优化搜索、筛选与浏览体验，努力让每一次找片都更轻松。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-3 md:gap-4">
              <div className="text-center p-4 rounded-lg bg-background-100 border border-background-200">
                <p className="font-heading font-extrabold text-2xl text-primary-600">20+</p>
                <p className="text-xs text-foreground-500 mt-1">示范影片资源</p>
              </div>
              <div className="text-center p-4 rounded-lg bg-background-100 border border-background-200">
                <p className="font-heading font-extrabold text-2xl text-primary-600">10</p>
                <p className="text-xs text-foreground-500 mt-1">影片类型频道</p>
              </div>
              <div className="text-center p-4 rounded-lg bg-background-100 border border-background-200">
                <p className="font-heading font-extrabold text-2xl text-accent-600">6</p>
                <p className="text-xs text-foreground-500 mt-1">覆盖制片地区</p>
              </div>
            </div>

            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mt-10 mb-4">
              <span>运营团队</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {team.map((member) => (
                <div key={member.name} className="flex gap-3 p-4 rounded-lg bg-background-50 border border-background-200">
                  <span className="w-11 h-11 rounded-md bg-primary-500 flex items-center justify-center shrink-0">
                    <i className={`${member.icon} text-accent-500 text-xl w-5 h-5 flex items-center justify-center`}></i>
                  </span>
                  <div>
                    <p className="font-heading font-bold text-sm text-foreground-950">
                      {member.name}
                      <span className="ml-2 text-xs font-normal text-accent-600">{member.role}</span>
                    </p>
                    <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{member.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <aside className="lg:sticky lg:top-20 lg:self-start">
            <div className="bg-background-50 rounded-lg border border-background-200 p-5">
              <h2 className="font-heading font-bold text-base text-foreground-950 mb-4">
                <span>联系方式</span>
              </h2>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center gap-3">
                  <i className="ri-mail-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-foreground-700">service@6080yy.example.com</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-time-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-foreground-700">服务时间：周一至周日 9:00 - 21:00</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-map-pin-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-foreground-700">线上服务，无实体门店</span>
                </li>
              </ul>
              <div className="mt-5 pt-4 border-t border-background-200 flex flex-wrap gap-3">
                <span className="w-9 h-9 rounded-md bg-background-100 text-foreground-600 flex items-center justify-center">
                  <i className="ri-wechat-line w-5 h-5 flex items-center justify-center"></i>
                </span>
                <span className="w-9 h-9 rounded-md bg-background-100 text-foreground-600 flex items-center justify-center">
                  <i className="ri-weibo-line w-5 h-5 flex items-center justify-center"></i>
                </span>
                <span className="w-9 h-9 rounded-md bg-background-100 text-foreground-600 flex items-center justify-center">
                  <i className="ri-mail-send-line w-5 h-5 flex items-center justify-center"></i>
                </span>
              </div>
            </div>

            <div className="mt-4 bg-accent-50 rounded-lg border border-accent-200 p-5">
              <h3 className="font-heading font-bold text-sm text-accent-900 mb-2">
                <span>版权声明</span>
              </h3>
              <p className="text-xs text-accent-900/80 leading-relaxed">
                本站所有影片信息与图片均为演示示范内容，仅用于产品展示与学习交流，不提供任何真实视频播放服务。如有侵权请联系我们处理。
              </p>
            </div>
          </aside>
        </div>

        <div className="mt-12">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2">
            <span>给我们留言</span>
          </h2>
          <p className="text-sm text-foreground-500 mb-5 max-w-2xl">
            对平台有任何建议、内容纠错或合作意向，欢迎通过下方表单与我们联系，我们会尽快回复。
          </p>
          <div className="max-w-3xl">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}